// extracted by mini-css-extract-plugin
export default {"message":"style_message__ST42P","success":"style_success__JJ7GD","error":"style_error__flOPP"};